import React from 'react'
import { Link } from '@inertiajs/react'

type Props = {
  children: React.ReactNode
}

export default function AuthLayout({ children }: Props) {
  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center">
      <Link href="/" className="text-2xl font-bold mb-8">
        konreji
      </Link>
      {children}
    </div>
  )
}
